"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var status_utils_1 = require("../../../utils/status.utils");
exports.default = (0, material_1.styled)(material_1.Box)(function (_a) {
    var _b = _a.status, status = _b === void 0 ? 'default' : _b, _c = _a.size, size = _c === void 0 ? 'medium' : _c;
    return ({
        display: 'inline-flex',
        alignItems: 'center',
        borderRadius: 9999,
        paddingTop: size === 'small' ? '0.4rem' : '0.8rem',
        paddingBottom: size === 'small' ? '0.4rem' : '0.8rem',
        paddingRight: '1.2rem',
        paddingLeft: '1.2rem',
        fontSize: size === 'small' ? '1.2rem' : '1.4rem',
        whiteSpace: 'nowrap',
        backgroundColor: (0, status_utils_1.statusColors)(status),
        height: size === 'small' ? '2.6rem' : '3.0rem',
    });
});
